import React from 'react';
import { useHistory } from 'react-router-dom';
import { Button } from 'rsuite';
import { usePermission } from '../../hooks/usePermission';

const ROTAS_POR_PERMISSAO = [
  { permissao: 'pedidos',       path: '/g_pedidos' },
  { permissao: 'cardapio',      path: '/g_produtos' },
  { permissao: 'relatorios',    path: '/g_consultarpedidos' },
  { permissao: 'configuracoes', path: '/g_configuracao' },
  { permissao: 'usuarios',      path: '/g_usuarios' },
  { permissao: 'entregadores',  path: '/g_entregadores' },
  { permissao: 'cupons',        path: '/g_cupons' },
  { permissao: 'fidelidade',    path: '/g_fidelidade' },
  { permissao: 'promocoes',     path: '/g_promocao' },
  { permissao: 'banners',       path: '/g_banners' },
  { permissao: 'empresa',       path: '/g_empresa' },
  { permissao: 'agendamento',   path: '/g_agendamento' },
  { permissao: 'chatbot',       path: '/chatbot/mensagens-personalizadas' },
];

const SemAcesso = () => {
  const history = useHistory();
  const { can } = usePermission();

  const handleVoltar = () => {
    const primeira = ROTAS_POR_PERMISSAO.find((r) => can(r.permissao));
    history.push(primeira ? primeira.path : '/g_avisos');
  };

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '80vh',
      gap: 16,
      textAlign: 'center',
      padding: 24,
    }}>
      <h2>Acesso Negado</h2>
      <p style={{ color: '#666', maxWidth: 400 }}>
        Você não tem permissão para acessar esta página. Entre em contato com o administrador do sistema.
      </p>
      <Button appearance="primary" onClick={handleVoltar}>
        Voltar
      </Button>
    </div>
  );
};

export default SemAcesso;
